"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_options_orchestration_1 = require("owa-options-orchestration");
var mobx_react_1 = require("mobx-react");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var styles = require('./OptionsFull.scss');
var OptionSearchSuggestion = /** @class */ (function (_super) {
    tslib_1.__extends(OptionSearchSuggestion, _super);
    function OptionSearchSuggestion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSuggestionClick = function () {
            var option = _this.props.option;
            owa_options_orchestration_1.navigateToSearchSuggestion(option.categoryKey, option.subcategoryKey, option.key);
        };
        return _this;
    }
    OptionSearchSuggestion.prototype.render = function () {
        var option = this.props.option;
        return (React.createElement(Button_1.CommandButton, tslib_1.__assign({}, this.props, { text: owa_options_strings_1.default[option.titleStringKey], onClick: this.onSuggestionClick, className: styles.suggestion })));
    };
    OptionSearchSuggestion = tslib_1.__decorate([
        mobx_react_1.observer
    ], OptionSearchSuggestion);
    return OptionSearchSuggestion;
}(React.Component));
exports.default = OptionSearchSuggestion;
//# sourceMappingURL=OptionSearchSuggestion.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/components/full/OptionSearchSuggestion.js
// module id = 5300
// module chunks = 2